// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        dynamicValues: {
          x: 'width * 0.5',
          y: 'height * 0.5'
        }
      }
    },
    {
      id: '9493f10a-5b79-4d50-9c89-67ebf4d0f7d4',
      type: 'Sprite',
      name: 'undoBoosterGradient',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 22.941176,
        y: 1.969231
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Gradient',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        dynamicValues: {
          width: 'width * 1.2',
          height: 'height'
        }
      }
    },
    {
      id: '8f927ea6-170d-4d4b-8500-7fa176fa09b2',
      type: 'Sprite',
      name: 'vortexPattern',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0.5,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Vortex',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '985998ee-6001-4763-a991-fe9b1aa5603f',
      type: 'Sprite',
      name: 'vortex',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.49,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 3,
        y: 3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Vortex_Part',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '66aa6e4b-c053-4915-8229-25236a5c7187',
      type: 'Sprite',
      name: 'shadow',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 3,
        y: 3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 139076,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Circle_Glow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '83b4fef8-1b9f-45ad-ba8a-62c24d0fe5fc',
      type: 'Sprite',
      name: 'triangleShine1',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 32,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Shine_Triangle',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '67cb6806-b234-4452-979b-cf9e3a2b1792',
      type: 'Sprite',
      name: 'triangleShine2',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: -32,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Shine_Triangle',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '0bd029a7-c2ba-4112-81f0-d2a7fc2f4b64',
      type: 'Sprite',
      name: 'triangleShine3',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: -162.8,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Shine_Triangle',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'df814c3e-f304-4203-85a2-59912f50514f',
      type: 'Sprite',
      name: 'shineDiamond',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Shine_Diamond',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '7b509215-6704-42f7-a818-3642d633e39c',
      type: 'Sprite',
      name: 'shineCircle',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.51,
        y: 0.52
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 3,
        y: 3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Shine_Circle',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'f0c2cc14-8da5-4bf1-9d71-bd0e0ffca907',
      type: 'Container',
      name: 'particleSpawnPoint',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '413bc529-ccf2-44b4-91eb-d670d23652cd',
      type: 'Sprite',
      name: 'clock',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Clock',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '2ead19fc-2fa3-4ac9-8c3c-60b27fd95821',
      type: 'Sprite',
      name: 'arrow',
      className: '',
      x: -4,
      y: 2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Arrow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '50d85c5a-27c8-4311-9cef-2f28e4ff15aa',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.49,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 45,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Vortex_Part',
      parent: '985998ee-6001-4763-a991-fe9b1aa5603f'
    },
    {
      id: '16d99d10-6539-41d0-9093-df29e3f5047e',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.49,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 90,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Vortex_Part',
      parent: '985998ee-6001-4763-a991-fe9b1aa5603f'
    },
    {
      id: 'd1f24e91-4648-4b03-90b7-074cb30f8ee0',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.49,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 135,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Vortex_Part',
      parent: '985998ee-6001-4763-a991-fe9b1aa5603f'
    },
    {
      id: '70c6317d-1a83-42db-95f4-6363204ca685',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.49,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Vortex_Part',
      parent: '985998ee-6001-4763-a991-fe9b1aa5603f'
    },
    {
      id: '55527250-b9a1-4b75-bfe7-e91ab584e89b',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.49,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 225,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Vortex_Part',
      parent: '985998ee-6001-4763-a991-fe9b1aa5603f'
    },
    {
      id: 'c4f6a5d4-64e7-40fa-8a7f-3047f1fd919b',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.49,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 270,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Vortex_Part',
      parent: '985998ee-6001-4763-a991-fe9b1aa5603f'
    },
    {
      id: '1dc5e31d-eecb-41fe-a532-e6bbebdc8a44',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.49,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 315,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Vortex_Part',
      parent: '985998ee-6001-4763-a991-fe9b1aa5603f'
    },
    {
      id: '19986529-2c03-4c1c-aa22-c6095449d03d',
      type: 'Sprite',
      name: 'clockNeedleBig',
      className: '',
      x: 0,
      y: -9,
      anchor: {
        x: -0.1,
        y: -0.1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Clock_Big_Needle',
      parent: '413bc529-ccf2-44b4-91eb-d670d23652cd'
    },
    {
      id: 'c33e7d91-6c7a-406a-b504-d62a3b2f50e3',
      type: 'Sprite',
      name: 'clockNeedleSmall',
      className: '',
      x: 0,
      y: -9,
      anchor: {
        x: -0.18,
        y: 1.18
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Clock_Small_Needle',
      parent: '413bc529-ccf2-44b4-91eb-d670d23652cd'
    },
    {
      id: '67e4f39d-3c23-4c1b-8b0c-9fc7b5ea8c4f',
      type: 'Sprite',
      name: 'clockMiddle',
      className: '',
      x: 0,
      y: -9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Clock_Middle',
      parent: '413bc529-ccf2-44b4-91eb-d670d23652cd'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  animations: [
    {
      id: 'ff36fa96-b416-4868-8930-b0daca3086aa',
      name: 'Undo_Booster_Animation',
      playingSpeed: 1,
      totalDuration: 1500,
      blocks: [
        {
          id: '8c643afe-ff79-4c11-b796-6cd46abe9be3',
          type: 'Setter',
          name: 'undoBoosterGradientAlpha',
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'undoBoosterGradient',
          disabled: false
        },
        {
          id: '51eea8dd-b255-49ab-84f9-1524352c91e2',
          type: 'Setter',
          name: 'vortexPatternAlpha',
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'vortexPattern',
          disabled: false
        },
        {
          id: '8902b5a3-545e-40a1-9ed6-e51524e1dc53',
          type: 'Setter',
          name: 'vortexAlpha',
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'vortex',
          disabled: false
        },
        {
          id: '9f325328-c936-4537-9c2a-4b9f6a924263',
          type: 'Setter',
          name: 'triangleShine1Alpha',
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'triangleShine1',
          disabled: false
        },
        {
          id: '569599eb-000f-4429-b417-faf821a4132a',
          type: 'Setter',
          name: 'triangleShine2Alpha',
          track: 5,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'triangleShine2',
          disabled: false
        },
        {
          id: '27d6588e-a1b9-42dd-84c7-666bf31a46e1',
          type: 'Setter',
          name: 'triangleShine3Alpha',
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'triangleShine3',
          disabled: false
        },
        {
          id: 'eec44c39-382f-46c4-8d39-d8379d43e475',
          type: 'Setter',
          name: 'shineDiamondAlpha',
          track: 7,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'shineDiamond',
          disabled: false
        },
        {
          id: '32ff391a-7101-4cd8-b8c3-94a58ff64a45',
          type: 'Setter',
          name: 'shineCircleScale',
          track: 8,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'shineCircle',
          disabled: false
        },
        {
          id: '1aa5f7e9-a2c6-4e0b-8eb4-388f62527338',
          type: 'Setter',
          name: 'arrowScale',
          track: 9,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'arrow',
          disabled: false
        },
        {
          id: '9a75e2c5-4ac8-482c-b3ec-0557c370a2c4',
          type: 'Setter',
          name: 'clockScale',
          track: 10,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'clock',
          disabled: false
        },
        {
          id: '13ba6e10-e70a-4d56-a6ea-67144932ffdd',
          type: 'Setter',
          name: 'shadowAlpha',
          track: 12,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'shadow',
          disabled: false
        },
        {
          id: 'c124cc00-6ef8-46a7-ae32-edd6f4a41c70',
          type: 'Setter',
          name: 'vortexPatternScale',
          track: 14,
          target: {
            scale: {
              x: 1.2,
              y: 1.2
            }
          },
          startAt: 0,
          sourceName: 'vortexPattern',
          disabled: false
        },
        {
          id: '0aaec205-c8b3-4801-8e45-e2e7b87fca28',
          type: 'Setter',
          name: 'clockNeedleBigRotation',
          track: 15,
          target: {
            angle: 360
          },
          startAt: 0,
          sourceName: 'clockNeedleBig',
          disabled: false
        },
        {
          id: '80dc9212-db16-4306-a31c-78be59bee22a',
          type: 'Setter',
          name: 'clockNeedleSmallRotation',
          track: 16,
          target: {
            angle: 270
          },
          startAt: 0,
          sourceName: 'clockNeedleSmall',
          disabled: false
        },
        {
          id: 'c6bbfc33-6cdb-4866-9ad6-1942dd36364d',
          type: 'Setter',
          name: 'FXPART_Undo_Booster_Animation_Particles',
          track: 17,
          target: {},
          startAt: 0,
          sourceName: 'particleSpawnPoint',
          disabled: false
        },
        {
          id: '4ba85353-b6ee-401e-8bdf-5e67176237ed',
          type: 'Setter',
          name: 'vortexRotation',
          track: 13,
          target: {
            angle: 0
          },
          startAt: 0,
          sourceName: 'vortex',
          disabled: false
        },
        {
          id: '8c9c7509-5017-4873-98a5-88e5fdeed9a0',
          type: 'Setter',
          name: 'shineDiamondAlpha',
          track: 7,
          target: {
            alpha: 1
          },
          startAt: 10,
          sourceName: 'shineDiamond',
          disabled: false
        },
        {
          id: '5c20bf9e-1141-4b36-b596-353cc98d5943',
          type: 'Setter',
          name: 'triangleShine3Alpha',
          track: 6,
          target: {
            alpha: 1
          },
          startAt: 10,
          sourceName: 'triangleShine3',
          disabled: false
        },
        {
          id: 'c7ddb72a-fa71-4ca8-8e81-c63065d559b6',
          type: 'Setter',
          name: 'triangleShine2Alpha',
          track: 5,
          target: {
            alpha: 1
          },
          startAt: 10,
          sourceName: 'triangleShine2',
          disabled: false
        },
        {
          id: '2310d2c8-2a62-4d88-8ec6-fd4cb537700c',
          type: 'Setter',
          name: 'triangleShine1Alpha',
          track: 4,
          target: {
            alpha: 1
          },
          startAt: 10,
          sourceName: 'triangleShine1',
          disabled: false
        },
        {
          id: '55ac26d4-d70d-46f7-9fb6-fcb4553563bf',
          type: 'Tween',
          name: 'vortexRotation',
          duration: 1490,
          track: 13,
          target: {
            angle: -160
          },
          startAt: 10,
          sourceName: 'vortex',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'bc292b3f-862a-454a-a821-fa8e01d89474',
          type: 'Tween',
          name: 'clockNeedleSmallRotation_1',
          duration: 1090,
          track: 16,
          target: {
            angle: 0
          },
          startAt: 10,
          sourceName: 'clockNeedleSmall',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5f2dddf8-c937-4fff-a21d-ba3b1c94d5dc',
          type: 'Tween',
          name: 'clockNeedleBigRotation',
          duration: 1090,
          track: 15,
          target: {
            angle: 0
          },
          startAt: 10,
          sourceName: 'clockNeedleBig',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '86a7da3b-a7e3-4d75-96c2-e9742a0a5f9e',
          type: 'Tween',
          name: 'vortexPatternScale_1',
          duration: 1490,
          track: 14,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 10,
          sourceName: 'vortexPattern',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'e32dae22-11d3-432a-b471-b22d18f8da4a',
          type: 'Tween',
          name: 'shadowAlpha_1',
          duration: 190,
          track: 12,
          target: {
            alpha: 1
          },
          startAt: 10,
          sourceName: 'shadow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'eb1be84d-6f30-45a9-b66e-80e0675fcf4a',
          type: 'Tween',
          name: 'shineCircleScale_1',
          duration: 390,
          track: 8,
          target: {
            scale: {
              x: 5,
              y: 5
            }
          },
          startAt: 10,
          sourceName: 'shineCircle',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'def6019e-5f38-4a5d-9b04-267123fd673a',
          type: 'Tween',
          name: 'vortexAlpha_1',
          duration: 190,
          track: 3,
          target: {
            alpha: 1
          },
          startAt: 10,
          sourceName: 'vortex',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '4279e125-8cd9-40ec-9f32-6a333a0ba6ff',
          type: 'Tween',
          name: 'vortexPatternAlpha',
          duration: 190,
          track: 2,
          target: {
            alpha: 0.5
          },
          startAt: 10,
          sourceName: 'vortexPattern',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b846b7ae-19b1-4207-97d3-3b2deeb903f0',
          type: 'Tween',
          name: 'undoBoosterGradientAlpha_1',
          duration: 190,
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 10,
          sourceName: 'undoBoosterGradient',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b01fcc03-1434-4dbe-994c-8edb9fefa6cd',
          type: 'Tween',
          name: 'shineDiamondScale',
          duration: 380,
          track: 7,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 20,
          sourceName: 'shineDiamond',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '43d6d83f-0885-4f0d-95ef-bf9d783d3d5a',
          type: 'Tween',
          name: 'triangleShine3Scale',
          duration: 380,
          track: 6,
          target: {
            scale: {
              x: 0
            }
          },
          startAt: 20,
          sourceName: 'triangleShine3',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '60cdb46f-d434-4331-9eba-aa9754417d5a',
          type: 'Tween',
          name: 'triangleShine2Scale',
          duration: 380,
          track: 5,
          target: {
            scale: {
              x: 0
            }
          },
          startAt: 20,
          sourceName: 'triangleShine2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '11a0cef2-4737-4cb9-b6dc-eed7290573f1',
          type: 'Tween',
          name: 'triangleShine1Scale',
          duration: 380,
          track: 4,
          target: {
            scale: {
              x: 0
            }
          },
          startAt: 20,
          sourceName: 'triangleShine1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '19b3ee60-c2c3-47db-a859-d69443b8d4c6',
          type: 'Tween',
          name: 'arrowScale_1',
          duration: 300,
          track: 9,
          target: {
            scale: {
              x: 1.2,
              y: 1.2
            }
          },
          startAt: 100,
          sourceName: 'arrow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '94276b7b-dab4-40b0-af08-145c54cad977',
          type: 'Tween',
          name: 'shineCircleAlpha',
          duration: 200,
          track: 11,
          target: {
            alpha: 0
          },
          startAt: 200,
          sourceName: 'shineCircle',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '50e0e5de-4afa-49b2-9673-719a74a889f0',
          type: 'Tween',
          name: 'clockScale_1_1',
          duration: 300,
          track: 10,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 200,
          sourceName: 'clock',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f540415e-8083-4f34-a9a4-d282766b693d',
          type: 'Setter',
          name: 'ANIMEVENT_performUndo',
          track: 18,
          target: {},
          startAt: 400,
          sourceName: 'root',
          disabled: false
        },
        {
          id: 'dc807d90-43f1-4bd1-8374-ee5f33ff846d',
          type: 'Tween',
          name: 'arrowScale_2_1',
          duration: 200,
          track: 9,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 400,
          sourceName: 'arrow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'be621577-9e33-499f-bba8-ef3dd1657247',
          type: 'Tween',
          name: 'clockScale_1',
          duration: 200,
          track: 10,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 500,
          sourceName: 'clock',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '56be4faa-b333-4c60-a05a-1303201f6408',
          type: 'Tween',
          name: 'shadowAlpha_2',
          duration: 300,
          track: 12,
          target: {
            alpha: 0
          },
          startAt: 1100,
          sourceName: 'shadow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '018b944e-0b58-4f2e-bf90-41efee18a4f4',
          type: 'Tween',
          name: 'vortexAlpha_2',
          duration: 300,
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 1100,
          sourceName: 'vortex',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c7a413b2-b5d7-4b62-8a04-c6cab349c10f',
          type: 'Tween',
          name: 'vortexPatternAlpha_1',
          duration: 300,
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 1100,
          sourceName: 'vortexPattern',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '693a2f65-fe4b-46e1-a1d8-b951d23bc819',
          type: 'Tween',
          name: 'clockScale_1_2',
          duration: 150,
          track: 10,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 1100,
          sourceName: 'clock',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '854a7a92-100d-4a2e-b948-a22ce383a23f',
          type: 'Tween',
          name: 'undoBoosterGradientAlpha_2_1',
          duration: 300,
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 1100,
          sourceName: 'undoBoosterGradient',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b069dd50-1b0c-414e-b59a-72c6f1b44ee9',
          type: 'Tween',
          name: 'arrowScale_2',
          duration: 150,
          track: 9,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 1200,
          sourceName: 'arrow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'faa16f56-0a5b-4eb6-853a-b1c99e76fce2',
          type: 'Tween',
          name: 'clockScale_1_3',
          duration: 150,
          track: 10,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 1250,
          sourceName: 'clock',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '30beeb74-1002-4395-8def-4a8e744ef6af',
          type: 'Tween',
          name: 'arrowScale_3',
          duration: 200,
          track: 9,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 1350,
          sourceName: 'arrow',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class UndoAnimationLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  undoBoosterGradient!: Sprite & { data: typeof raw['list'][1]['data'] };
  vortexPattern!: Sprite;
  vortex!: Sprite;
  shadow!: Sprite;
  triangleShine1!: Sprite;
  triangleShine2!: Sprite;
  triangleShine3!: Sprite;
  shineDiamond!: Sprite;
  shineCircle!: Sprite;
  particleSpawnPoint!: Container;
  clock!: Sprite;
  arrow!: Sprite;
  clockNeedleBig!: Sprite;
  clockNeedleSmall!: Sprite;
  clockMiddle!: Sprite;
  dynamicProps_SPL!: (Container & { data: typeof raw['list'][0]['data'] } | Sprite & { data: typeof raw['list'][1]['data'] })[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Undo_Booster_Animation {
  Layout: {
    undoBoosterGradient: object;
    vortexPattern: object;
    vortex: object;
    triangleShine1: object;
    triangleShine2: object;
    triangleShine3: object;
    shineDiamond: object;
    shineCircle: object;
    arrow: object;
    clock: object;
    shadow: object;
    clockNeedleBig: object;
    clockNeedleSmall: object;
    particleSpawnPoint: object;
    root: object;
  };

  BlockTypeByName: {
    undoBoosterGradientAlpha: object;
    vortexPatternAlpha: object;
    vortexAlpha: object;
    triangleShine1Alpha: object;
    triangleShine2Alpha: object;
    triangleShine3Alpha: object;
    shineDiamondAlpha: object;
    shineCircleScale: object;
    arrowScale: object;
    clockScale: object;
    shadowAlpha: object;
    vortexPatternScale: object;
    clockNeedleBigRotation: object;
    clockNeedleSmallRotation: object;
    FXPART_Undo_Booster_Animation_Particles: object;
    vortexRotation: object;
    shineDiamondAlpha: object;
    triangleShine3Alpha: object;
    triangleShine2Alpha: object;
    triangleShine1Alpha: object;
    vortexRotation: object;
    clockNeedleSmallRotation_1: object;
    clockNeedleBigRotation: object;
    vortexPatternScale_1: object;
    shadowAlpha_1: object;
    shineCircleScale_1: object;
    vortexAlpha_1: object;
    vortexPatternAlpha: object;
    undoBoosterGradientAlpha_1: object;
    shineDiamondScale: object;
    triangleShine3Scale: object;
    triangleShine2Scale: object;
    triangleShine1Scale: object;
    arrowScale_1: object;
    shineCircleAlpha: object;
    clockScale_1_1: object;
    ANIMEVENT_performUndo: object;
    arrowScale_2_1: object;
    clockScale_1: object;
    shadowAlpha_2: object;
    vortexAlpha_2: object;
    vortexPatternAlpha_1: object;
    clockScale_1_2: object;
    undoBoosterGradientAlpha_2_1: object;
    arrowScale_2: object;
    clockScale_1_3: object;
    arrowScale_3: object;
  };

  flowData = raw.animations[0];
}
